import images from "./images";


const portfolio = [ 
    {
        id: 1,
        image: images.portfolio1,
        title: "Luxury SUV Rental",
        details: {
            date: "April 5, 2025",
            client: "Travelers & Business Professionals",
            category: "Vehicles",
            duration: "Flexible Rental Plans",
            location: "Nationwide",
            cost: "Competitive Luxury Pricing",
            projectLead: "Michael Johnson"
        },
        paragraphs: [
            "Experience the ultimate in comfort and style with our Luxury SUV Rental service. Our fleet of high-end SUVs offers premium interiors, advanced safety features, and smooth performance for an exceptional driving experience.",
            "Whether you're on a business trip, a family vacation, or just want to drive in style, our luxury SUVs provide unparalleled convenience and sophistication. With flexible rental plans and top-tier customer service, we make luxury accessible."
        ],
        gallery: [
            images.portfolio1Gallery1,
            images.portfolio1Gallery2,
            images.portfolio1Gallery3,
            images.portfolio1Gallery4,
            images.portfolio1Gallery5,
            images.portfolio1Gallery6,
        ],
        challenges: [
            "Limited availability of premium rental vehicles",
            "High rental costs for luxury cars",
            "Inconsistent vehicle maintenance and cleanliness",
            "Lack of flexible rental options for customers"
        ],
        solutions: [
            "Wide selection of top-brand luxury SUVs",
            "Affordable pricing with no hidden fees",
            "Regular maintenance and thorough cleaning",
            "Customizable rental plans to suit different needs"
        ],
        results: [
            "Increased accessibility to luxury vehicles",
            "Enhanced customer satisfaction with premium service",
            "Convenient and hassle-free rental experience",
            "Superior driving comfort and safety features"
        ]
    },
    {
        id: 2,
        image: images.portfolio2,
        title: "Budget Car Rentals",
        details: {
            date: "April 5, 2025",
            client: "Travelers & Everyday Commuters",
            category: "Vehicles",
            duration: "Flexible Rental Plans",
            location: "Nationwide",
            cost: "Economical Pricing",
            projectLead: "Emma Roberts"
        },
        paragraphs: [
            "Enjoy reliable and affordable transportation with our Budget Car Rentals. Our fleet of fuel-efficient and well-maintained vehicles ensures a smooth and cost-effective driving experience for any journey.",
            "Whether you're commuting, running errands, or traveling on a budget, our rental cars offer unbeatable value with flexible plans and outstanding customer service. Drive more, spend less!"
        ],
        gallery: [
            images.portfolio2Gallery1,
            images.portfolio2Gallery2,
            images.portfolio2Gallery3,
            images.portfolio2Gallery4,
            images.portfolio2Gallery5,
            images.portfolio2Gallery6,
        ],
        challenges: [
            "High rental costs for budget travelers",
            "Limited options for fuel-efficient vehicles",
            "Hidden fees and complicated rental terms",
            "Lack of convenient pick-up and drop-off locations"
        ],
        solutions: [
            "Affordable pricing with no hidden charges",
            "A diverse selection of fuel-efficient cars",
            "Transparent rental terms and conditions",
            "Multiple pick-up and drop-off points nationwide"
        ],
        results: [
            "Cost-effective travel solutions for customers",
            "Increased access to reliable budget vehicles",
            "Smooth and transparent rental process",
            "Higher customer satisfaction with affordable pricing"
        ]
    },
    {
        id: 3,
        image: images.portfolio3,
        title: "Airport Car Rental",
        details: {
            date: "April 5, 2025",
            client: "Frequent Flyers & Business Travelers",
            category: "Services",
            duration: "Short-Term & Long-Term Rentals",
            location: "Major Airports Nationwide",
            cost: "Competitive Pricing",
            projectLead: "James Carter"
        },
        paragraphs: [
            "Make your airport travel seamless with our Airport Car Rental service. Offering a range of vehicles from economy to luxury, we ensure hassle-free pick-up and drop-off right at the terminal.",
            "Designed for business professionals and frequent travelers, our service includes flexible rental options, 24/7 availability, and priority customer support to make your journey smooth and stress-free."
        ],
        gallery: [
            images.portfolio3Gallery1,
            images.portfolio3Gallery2,
            images.portfolio3Gallery3,
            images.portfolio3Gallery4,
            images.portfolio3Gallery5,
            images.portfolio3Gallery6,
        ],
        challenges: [
            "Limited transport options at airports",
            "Expensive last-minute rentals",
            "Long waiting times for rental services",
            "Inconvenient pick-up and drop-off locations"
        ],
        solutions: [
            "Easy online booking and pre-reservation",
            "Competitive pricing with no surprise fees",
            "Fast-track rental services with priority support",
            "Dedicated airport locations for quick pick-up and return"
        ],
        results: [
            "Faster and more convenient airport transport",
            "Reduced stress for frequent travelers",
            "Affordable and flexible rental solutions",
            "Enhanced customer satisfaction and loyalty"
        ]
    },
    {
        id: 4,
        image: images.portfolio4,
        title: "24/7 Roadside Assistance",
        details: {
            date: "April 5, 2025",
            client: "All Car Renters",
            category: "Customer",
            duration: "Round-the-Clock Service",
            location: "Nationwide Coverage",
            cost: "Included with Rental Plans",
            projectLead: "Michael Johnson"
        },
        paragraphs: [
            "Drive with confidence knowing that our 24/7 Roadside Assistance is always available. Whether you have a flat tire, need a jump-start, or run out of fuel, we are just a call away to get you back on the road.",
            "Our service ensures peace of mind with quick response times, professional assistance, and nationwide coverage. Enjoy worry-free rentals with support available anytime, anywhere."
        ],
        gallery: [
            images.portfolio4Gallery1,
            images.portfolio4Gallery2,
            images.portfolio4Gallery3,
            images.portfolio4Gallery4,
            images.portfolio4Gallery5,
            images.portfolio4Gallery6,
        ],
        challenges: [
            "Unexpected car breakdowns",
            "Limited access to repair services",
            "Long wait times for roadside assistance",
            "Additional costs for emergency support"
        ],
        solutions: [
            "24/7 availability for immediate assistance",
            "Nationwide service network for quick response",
            "No additional fees for covered incidents",
            "Experienced professionals ensuring quality support"
        ],
        results: [
            "Increased customer confidence while traveling",
            "Reduced downtime in case of emergencies",
            "Seamless and stress-free car rental experience",
            "Higher customer satisfaction and retention"
        ]
    },
    {
        id: 5,
        image: images.portfolio5,
        title: "Convertible Rentals",
        details: {
            date: "April 5, 2025",
            client: "Luxury Travelers",
            category: "Vehicles",
            duration: "Flexible Rental Periods",
            location: "Nationwide Availability",
            cost: "Competitive Pricing",
            projectLead: "Emily Carter"
        },
        paragraphs: [
            "Experience the thrill of the open road with our premium convertible rentals. Perfect for scenic drives, coastal getaways, and stylish city cruising, our fleet includes top brands known for performance and comfort.",
            "Enjoy the freedom of a retractable roof, luxurious interiors, and smooth handling. Whether it's a weekend adventure or a special occasion, our convertible rentals add excitement to your journey."
        ],
        gallery: [
            images.portfolio5Gallery1,
            images.portfolio5Gallery2,
            images.portfolio5Gallery3,
            images.portfolio5Gallery4,
            images.portfolio5Gallery5,
            images.portfolio5Gallery6,
        ],
        challenges: [
            "Limited availability of high-end convertibles",
            "High rental costs for luxury vehicles",
            "Concerns about weather conditions affecting rentals",
            "Need for flexible rental durations"
        ],
        solutions: [
            "Diverse selection of premium convertibles",
            "Affordable pricing plans for different budgets",
            "Weather protection policies for added assurance",
            "Customizable rental periods for convenience"
        ],
        results: [
            "Enhanced customer experience with luxury rentals",
            "More travelers enjoying stylish and fun drives",
            "Increased demand for convertible rentals",
            "Higher satisfaction and repeat bookings"
        ]
    },
    {
        id: 6,
        image: images.portfolio6,
        title: "Online Booking & Management",
        details: {
            date: "April 5, 2025",
            client: "Car Renters",
            category: "Services",
            duration: "Instant & Flexible Scheduling",
            location: "Global Accessibility",
            cost: "Transparent Pricing",
            projectLead: "David Johnson"
        },
        paragraphs: [
            "Streamline your car rental experience with our advanced online booking and management system. Designed for convenience, our platform allows users to browse available vehicles, select rental periods, and complete bookings seamlessly.",
            "With real-time availability updates, secure payment processing, and easy modifications, our system ensures a hassle-free rental process. Whether booking in advance or on the go, enjoy complete control over your car rental experience."
        ],
        gallery: [
            images.portfolio6Gallery1,
            images.portfolio6Gallery2,
            images.portfolio6Gallery3,
            images.portfolio6Gallery4,
            images.portfolio6Gallery5,
            images.portfolio6Gallery6,
        ],
        challenges: [
            "Time-consuming manual booking processes",
            "Lack of real-time vehicle availability",
            "Complex pricing structures",
            "Difficulty in modifying bookings"
        ],
        solutions: [
            "User-friendly online reservation platform",
            "Live updates on vehicle availability",
            "Transparent and competitive pricing models",
            "Flexible booking modification options"
        ],
        results: [
            "Faster and easier rental bookings",
            "Improved customer satisfaction with seamless access",
            "Reduced booking errors and delays",
            "Higher customer retention and repeat rentals"
        ]
    }
];

export default portfolio;